// extracted by extract-css-chunks-webpack-plugin
module.exports = {"preface":"preface_7rM0n"};